import { useMemo, useState } from 'react'

function VansFormula() {
  const [text, setText] = useState('ANS')

  const display = text.trim() === '' ? 'ANS' : text.toUpperCase()

  // Estimate width so the radical bar covers the text
  const charWidth = 17
  const textWidth = useMemo(() => Math.max(40, display.length * charWidth), [display])
  const svgWidth = textWidth + 60

  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <div className="rounded-2xl border border-white/8 bg-[#0b1020] p-6 shadow-xl shadow-black/40">
        <label htmlFor="vans-input" className="mb-2 block text-sm font-medium text-slate-300">
          Type any word or equation
        </label>
        <input
          id="vans-input"
          type="text"
          value={text}
          maxLength={16}
          placeholder="ANS"
          onChange={(e) => setText(e.target.value)}
          className="w-full rounded-xl border border-white/8 bg-[#070a13] px-4 py-3 font-mono text-lg text-white focus:border-indigo-400 focus:outline-none"
        />

        <div className="mt-6 space-y-3 rounded-xl border border-white/8 bg-white/[0.02] p-4 text-sm leading-relaxed text-slate-400">
          <p className="font-display font-semibold text-white">Step-by-step joke sheet</p>
          <p>
            <span className="font-mono text-emerald-400">1.</span> The Vans "Off The Wall" logo is
            secretly the square root of <span className="font-mono text-indigo-300">{display}</span>.
          </p>
          <p>
            <span className="font-mono text-emerald-400">2.</span> Skaters take{' '}
            <span className="font-mono text-indigo-300">√{display}</span> because the answer is always{' '}
            <span className="font-mono text-indigo-300">{display}</span> — radical, irrational, and
            unbothered.
          </p>
          <p>
            <span className="font-mono text-emerald-400">3.</span> Memetic branding like this fuels
            organic viral traffic: a single in-joke turns into thousands of search queries and free
            backlinks.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center rounded-2xl border border-white/8 bg-gradient-to-br from-[#0c1322] to-[#0a0f1c] p-6 shadow-xl shadow-black/40">
        <svg
          width={svgWidth}
          height="90"
          viewBox={`0 0 ${svgWidth} 90`}
          role="img"
          aria-label={`Square root of ${display}`}
          className="max-w-full"
        >
          <path
            d="M4 58 L14 58 L24 78 L40 24 L60 24"
            fill="none"
            stroke="#10b981"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <line
            x1="58"
            y1="24"
            x2={svgWidth - 6}
            y2="24"
            stroke="#10b981"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <text
            x={58 + textWidth / 2}
            y="62"
            textAnchor="middle"
            className="font-mono"
            fontSize="34"
            fontWeight="700"
            fill="#ffffff"
          >
            {display}
          </text>
        </svg>
      </div>
    </div>
  )
}

export default VansFormula
